// import React from "react";
// import { Link } from "react-router";

// const Home = () => {
//   return (
//     <>
//       <section className="container mx-auto py-10 px-10">
//         <div className="grid lg:grid-cols-2 gap-5">
//           <div>
//             <div className="bg-cy h-72 content-end  shadow-lg">
//               <div className=" justify-items-center">
//                 <img
//                   src="/assets/img/home/care.png"
//                   className="lg:w-3/12 w-6/12"
//                   alt=""
//                 />
//               </div>
//             </div>
//             <div>
//               <h1 className="py-5 text-lg font-bold">
//                 CareCircle: Healthcare Scheduling App
//               </h1>
//               <Link
//                 to="/carecircle"
//                 className="lg:w-4/12 w-full  justify-between flex capitalize border-2 border-black p-2  rounded-full shadow-lg hover:bg-cy "
//               >
//                 <span className="pl-2">view case Study</span>
//                 <img src="/assets/img/arrow.png" alt="" />
//               </Link>
//             </div>
//           </div>
//           <div>
//             <div className="bg-cg h-72 content-end shadow-lg">
//               <div className="justify-items-center">
//                 <img
//                   src="/assets/img/home/plusefit.png"
//                   className="lg:w-3/12 w-6/12"
//                   alt=""
//                 />
//               </div>
//             </div>
//             <div>
//               <h1 className="py-5 text-lg font-bold">PulseFit: Workout App</h1>

//               <Link
//                 to="/pulsefit"
//                 className="lg:w-4/12 w-full justify-between flex capitalize border-2 border-black p-2  rounded-full shadow-lg hover:bg-blue-200 "
//               >
//                 <span className="pl-2">view case Study</span>
//                 <img src="/assets/img/arrow.png" alt="" />
//               </Link>
//             </div>
//           </div>
//         </div>
//       </section>
//     </>
//   );
// };

// export default Home;
import React from "react";
import { Link } from "react-router";

const Home = () => {
  return (
    <>
      <section className="container mx-auto py-10 xl:py-10  px-5 sm:px-8 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
          {/* CareCircle Section */}
          <div>
            <div className="bg-cy h-48 sm:h-60 md:h-64 lg:h-72 flex items-end justify-center shadow-lg">
              <img
                src="/assets/img/home/care.png"
                className="w-4/12 sm:w-4/12 md:w-3/12 lg:w-3/12"
                alt="CareCircle Logo"
              />
            </div>
            <div>
              <h1 className="py-5 text-lg sm:text-xl md:text-xl font-bold">
                CareCircle: Healthcare Scheduling App
              </h1>
              {/* <Link
                to="/carecircle"
                className="w-full sm:w-6/12 md:w-5/12 lg:w-5/12 flex items-center justify-between border-2 border-black p-2 rounded-full shadow-lg hover:bg-cy transition-colors duration-200"
              >
                <span className="pl-2 text-sm sm:text-base">
                  View Case Study
                </span>
                <img src="/assets/img/arrow.png" alt="Arrow Icon" />
              </Link> */}
              <Link
                to="/carecircle"
                className="w-full sm:w-6/12 md:w-5/12 lg:w-5/12 flex items-center justify-between border-2 border-black p-2 rounded-full shadow-lg hover:shadow-xl transition-transform duration-200 transform hover:-translate-y-1 active:translate-y-1 hover:bg-cy"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.2), 0 1px 3px rgba(0, 0, 0, 0.1)",
                }}
              >
                <span className="pl-2 text-sm sm:text-base font-semibold ">
                  View Case Study
                </span>
                <img src="/assets/img/arrow.png" alt="Arrow Icon" />
              </Link>
            </div>
          </div>
          {/* PulseFit Section */}
          <div>
            <div className="bg-cg h-48 sm:h-60 md:h-64 lg:h-72 flex items-end justify-center shadow-lg">
              <img
                src="/assets/img/home/plusefit.png"
                className="w-4/12 sm:w-4/12 md:w-3/12 lg:w-3/12"
                alt="PulseFit Logo"
              />
            </div>
            <div>
              <h1 className="py-5 text-lg sm:text-xl md:text-xl font-bold">
                PulseFit: Workout App
              </h1>
              {/* <Link
                to="/pulsefit"
                className="w-full sm:w-6/12 md:w-5/12 lg:w-5/12 flex items-center justify-between border-2 border-black p-2 rounded-full shadow-lg hover:bg-blue-200 transition-colors duration-200"
              >
                <span className="pl-2 text-sm sm:text-base">View Case Study</span>
                <img src="/assets/img/arrow.png" alt="Arrow Icon" />
              </Link> */}
              <Link
                to="/pulsefit"
                className="w-full sm:w-6/12 md:w-5/12 lg:w-5/12 flex items-center justify-between border-2 border-black p-2 rounded-full shadow-lg hover:shadow-xl transition-transform duration-200 transform hover:-translate-y-1 active:translate-y-1 hover:bg-cg"
                style={{
                  boxShadow:
                    "0 4px 6px rgba(0, 0, 0, 0.2), 0 1px 3px rgba(0, 0, 0, 0.1)",
                }}
              >
                <span className="pl-2 text-sm sm:text-base font-semibold ">
                  View Case Study
                </span>
                <img src="/assets/img/arrow.png" alt="Arrow Icon" />
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Home;
